// Mirrors THREAD_BUSY_NOTICE in src/apps/api/.../routers/stream_common.py —
// the stream's error chunk only carries a string, so this exact text is the
// contract for telling "another stream is running" apart from a real failure.
const THREAD_BUSY_TEXT =
  'The assistant is still responding in this conversation. Please wait for it to finish.'

/** Who failed when a chat request did: nobody (`busy`), the path to the assistant, or the assistant. */
export type TransportFailure = 'busy' | 'connection' | 'assistant'

export function classifyTransportFailure(error: Error): TransportFailure {
  const message = error.message || String(error)
  if (message.includes(THREAD_BUSY_TEXT)) return 'busy'
  // A request or a response body that dies in transit rejects with a TypeError carrying the
  // browser's own words ("network error", "Load failed"). A gateway that could not reach the
  // API answers 502–504 itself, which the runtime throws as "Status <code>: <its page>".
  if (error instanceof TypeError || /^Status 50[234]\b/.test(message)) return 'connection'
  return 'assistant'
}
